<template>
  <div class="mt-3">
    <div class="header-purple">
      <div>
        <p class="mb-0">
          <strong>
            ส่วนลดโปรโมชัน
            <b-button
              v-if="collapseHeader"
              variant="link"
              size="sm"
              class="btn-collapse mb-1"
              @click="collapseHeader = false"
            >
              <b-icon icon="chevron-down"></b-icon>
            </b-button>
            <b-button
              v-if="!collapseHeader"
              variant="link"
              size="sm"
              class="btn-collapse mb-1"
              @click="collapseHeader = true"
            >
              <b-icon icon="chevron-up"></b-icon>
            </b-button>
          </strong>
        </p>
      </div>
    </div>
    <b-collapse v-model="collapseHeader" class="collapse-header">
      <div class="bg-white p-4">
        <b-container class="p-0">
          <b-row
            v-if="
              form.promotion.promotionTypeId == 3 ||
                form.promotion.promotionTypeId == 4
            "
          >
            <b-col sm="6">
              <InputText
                :textFloat="
                  `ส่วนลด (${
                    form.promotion.promotionTypeId == 3 ? 'บาท' : '%'
                  })`
                "
                v-model="form.privilage.minimumPrice"
                isRequired
                class="ml-1 mt-2"
                placeholder="0"
                type="number"
                disableDot
                :isValidate="v.privilage.minimumPrice.$error"
                :v="v.privilage.minimumPrice"
              />
            </b-col>
          </b-row>
          <b-row
            v-if="
              form.promotion.promotionTypeId == 5 ||
                form.promotion.promotionTypeId == 6
            "
          >
            <b-col sm="6" v-if="form.promotion.promotionTypeId == 6">
              <InputText
                textFloat="จำนวนชิ้นของแถม (Y)"
                v-model="form.privilage.minimumPrice"
                isRequired
                class="ml-1 mt-2"
                placeholder="0"
                type="number"
                disableDot
                :isValidate="v.privilage.minimumPrice.$error"
                :v="v.privilage.minimumPrice"
              /> </b-col
            ><b-col
              sm="6"
              v-if="
                form.promotion.promotionTypeId == 5 ||
                  form.promotion.promotionTypeId == 6
              "
            >
              <InputText
                textFloat="จำนวนครั้งในการแถม (Y)"
                v-model="form.privilage.limitRound"
                class="ml-1 mt-2"
                placeholder="0"
                type="number"
              />
            </b-col>
          </b-row>
          <b-row v-if="form.promotion.promotionTypeId == 7">
            <b-col sm="6">
              <div class="ml-1 mt-2 mb-2 div-input">
                <InputSelect
                  title="ประเภทส่วนลดขนส่ง"
                  name="typeShipping"
                  v-model="form.privilage.minimumTypeId"
                  v-bind:options="shippingMinimumType"
                  valueField="value"
                  textField="text"
                  @onDataChange="changeShippingType"
                />
              </div>
            </b-col>
            <b-col sm="6"></b-col>
            <b-col sm="6" v-if="form.privilage.minimumTypeId != 6">
              <InputText
                :textFloat="
                  `ส่วนลดราคาขนส่ง (${
                    form.privilage.minimumTypeId == 2 ? '%' : 'บาท'
                  })`
                "
                v-model="form.privilage.minimumPrice"
                isRequired
                class="ml-1 mt-2"
                placeholder="0"
                type="number"
                disableDot
                :isValidate="v.privilage.minimumPrice.$error"
                :v="v.privilage.minimumPrice"
              />
              <p class="text-danger mt-3" v-if="errorBuyXGetY">
                The number of applied product must equals to number of X product
                (Action)
              </p>
            </b-col>
          </b-row>
          <b-row
            v-if="
              form.promotion.promotionTypeId == 3 ||
                form.promotion.promotionTypeId == 4 ||
                form.promotion.promotionTypeId == 7 ||
                form.promotion.promotionTypeId == 8
            "
          >
            <b-col sm="12">
              <div class="mt-2 ml-1">
                <b-form-group>
                  <b-form-checkbox
                    v-model="form.promotion.useSameCondition"
                    @change="changeSameScope"
                    >ใช้ขอบเขตเดียวกับด้านบน</b-form-checkbox
                  >
                </b-form-group>
              </div>
            </b-col>
            <b-col sm="12">
              <div class="ml-1">
                <b-form-group>
                  <b-form-checkbox v-model="form.privilage.skipPromotionPrice"
                    >ยกเว้นสินค้าราคาโปรโมชัน</b-form-checkbox
                  >
                </b-form-group>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col sm="6">
              <div class="ml-1 mt-2 div-input">
                <InputSelect
                  title="ขอบเขตเงื่อนไข"
                  name="scopeD"
                  v-model="
                    form.privilage.promotionConditionScope.promotionScopeTypeId
                  "
                  v-bind:options="promotionScope"
                  valueField="value"
                  textField="text"
                  @onDataChange="changeScope"
                  :disabled="
                    form.promotion.promotionTypeId == 5 ||
                      form.promotion.promotionTypeId == 6
                  "
                />
              </div>
            </b-col>
            <b-col
              sm="6"
              v-if="
                form.privilage.promotionConditionScope.promotionScopeTypeId == 1
              "
            >
              <div class="ml-1 mt-2 div-input">
                <InputSelect
                  title="เลือกประเภท"
                  name="scopeTypeD"
                  v-model="
                    form.privilage.promotionConditionScope
                      .conditionOperationTypeId
                  "
                  v-bind:options="promotionScopeType"
                  valueField="value"
                  textField="text"
                  @onDataChange="changeScopeType"
                />
              </div>
            </b-col>
          </b-row>
          <b-row
            v-if="
              form.privilage.promotionConditionScope.promotionScopeTypeId == 1
            "
          >
            <b-col sm="6">
              <div class="mt-4">
                <b-button
                  class="btn-purple btn-select-product ml-1 btn-table-select"
                  @click="importPromotionData()"
                  ><div class="px-1">
                    <span class="font-weight-bold">นำข้อมูลเข้า</span>
                  </div></b-button
                >
                <b-button
                  class="btn-filter btn-select-product ml-1 btn-table-select"
                  @click="openProductModal"
                  ><div class="px-1">
                    <span class="float-left font-weight-bold">เลือกสินค้า</span
                    ><span class="float-right"
                      ><b-icon icon="chevron-right"></b-icon
                    ></span></div
                ></b-button>
                <span class="ml-2 font-weight-bold"
                  >รายการที่เลือก
                  {{
                    form.privilage.promotionConditionScope.productOrCategoryList
                      .length | numeral("0,0")
                  }}
                  รายการ</span
                >
              </div>
            </b-col>
            <b-col sm="6">
              <b-form-input
                id="product-search-select"
                class="ml-1 mt-3 search-input"
                placeholder="ค้นหาด้วยชื่อสินค้า, SKU"
                v-model="filterProductSelect.search"
                v-on:keyup.13="submitFilter()"
                @blur="submitFilter()"
              ></b-form-input>
            </b-col>
            <b-col sm="12">
              <b-table
                responsive
                striped
                sticky-header
                class="mt-2 text-center table-list"
                :fields="computedFields"
                :items="productListSelectDisplay"
                :busy="isBusy"
                show-empty
                empty-text="ไม่พบข้อมูล"
              >
                <template v-slot:cell(isApply)="data">
                  <b-form-group class="cb-table">
                    <b-form-checkbox
                      v-model="data.item.isApply"
                    ></b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(imageUrl)="data">
                  <div>
                    <div
                      v-if="data.item.imageUrl"
                      class="table-image"
                      v-bind:style="{
                        'background-image': 'url(' + data.item.imageUrl + ')',
                      }"
                    ></div>
                    <div v-else>-</div>
                  </div>
                </template>
                <template v-slot:cell(name)="data">
                  <div class="text-left">
                    <p class="m-0" v-if="data.item.name">
                      {{ data.item.name }}
                    </p>
                    <p class="m-0 text-gray" v-if="data.item.name">
                      {{ data.item.sku }}
                    </p>
                    <p v-else class="m-0">-</p>
                  </div>
                </template>
                <template v-slot:cell(barcode)="data">
                  <p class="m-0" v-if="data.item.barcode">
                    {{ data.item.barcode }}
                  </p>
                  <p v-else class="m-0">-</p>
                </template>

                <template v-slot:cell(price)="data">
                  <p class="m-0 price-text" v-if="data.item.price">
                    ฿ {{ data.item.price | numeral("0,0.00") }}
                  </p>
                  <p v-else class="m-0 price-text">-</p>
                </template>
                <template v-slot:cell(quantity)="data">
                  <InputText
                    textFloat=""
                    v-model="data.item.quantity"
                    class="ml-1 mt-2"
                    placeholder="0"
                    type="number"
                    disableDot
                  />
                </template>
                <template v-slot:cell(type)="data">
                  <InputSelect
                    title=""
                    name="typeDiscount"
                    v-model="data.item.minimumTypeId"
                    v-bind:options="typeDiscountOption"
                    valueField="value"
                    class="ml-1 mt-2"
                    textField="text"
                    @onDataChange="(val) => (data.item.minimumTypeId = val)"
                  />
                </template>
                <template v-slot:cell(discount)="data">
                  <InputText
                    textFloat=""
                    v-model="data.item.minimumPrice"
                    class="ml-1 mt-2"
                    placeholder="0"
                    type="number"
                    disableDot
                  />
                </template>
                <template v-slot:cell(delete)="data">
                  <span
                    class="float-right pointer"
                    @click="deleteProduct(data.item.index)"
                    ><b-icon icon="trash-fill"></b-icon
                  ></span>
                </template>

                <template v-slot:table-busy>
                  <div class="text-center text-black my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ml-2">Loading...</strong>
                  </div>
                </template>
              </b-table>
            </b-col>
            <b-col sm="4"
              >ผลลัพธ์
              {{
                filterProductSelect.perPage > rowsSelect
                  ? rowsSelect
                  : filterProductSelect.perPage
              }}
              รายการ จากทั้งหมด {{ rowsSelect }} รายการ</b-col
            >
            <b-col sm="8">
              <b-row class="px-3 pb-3">
                <b-col class="form-inline justify-content-end">
                  <div class="d-sm-flex mr-3">
                    <b-pagination
                      v-model="filterProductSelect.pageNo"
                      :total-rows="rowsSelect"
                      :per-page="filterProductSelect.perPage"
                      class="m-md-0 page-item"
                      @change="pagination"
                    ></b-pagination>
                  </div>
                  <b-form-select
                    v-model="filterProductSelect.perPage"
                    @change="hanndleChangePerpage"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" v-if="v.appliedProduct.$error">
              <p class="text-danger">จำนวนสินค้าที่ต้องการแถมต้องมากกว่า 0</p>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import UploadFile from "@/components/inputs/UploadFile";
import { BIcon } from "bootstrap-vue";
export default {
  name: "DiscountPanel",
  components: { BIcon, InputText, InputSelect, UploadFile },
  props: {
    id: {
      type: Number,
      isRequired: true,
    },
    form: {
      type: Object,
      isRequired: true,
    },
    productIdList: {
      type: Array,
      isRequired: true,
    },
    productNameList: {
      type: Array,
      isRequired: true,
    },
    promotionScope: {
      type: Array,
      isRequired: true,
    },
    promotionScopeType: {
      type: Array,
      isRequired: true,
    },
    filterProductSelectDefault: {
      type: String,
      isRequired: true,
    },
    errorBuyXGetY: {
      type: Boolean,
      isRequired: true,
    },
    discountProductError: {
      type: Boolean,
      isRequired: true,
    },
    v: {
      type: Object,
      isRequired: true,
    },
  },
  data() {
    return {
      collapseHeader: true,
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      filterProductSelect: JSON.parse(this.filterProductSelectDefault),
      rowsSelect: 0,
      fields: [
        {
          key: "isApply",
          label: "Complimentary",
          class: "w-50px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "7% !important",
          },
          type: 3,
        },
        {
          key: "imageUrl",
          label: "รูปภาพ",
          class: "w-50px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "11% !important",
          },
          type: 0,
        },
        {
          key: "name",
          label: "ชื่อสินค้า (SKU)",
          class: "w-100px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "22% !important",
          },
          type: 0,
        },
        {
          key: "barcode",
          label: "บาร์โค้ด",
          class: "w-50px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "12% !important",
          },
          type: 0,
        },
        {
          key: "price",
          label: "ราคา",
          class: "w-50px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "12% !important",
          },
          type: 0,
        },
        {
          key: "quantity",
          label: "จำนวน",
          class: "w-50px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "10% !important",
          },
          type: 1,
        },
        {
          key: "type",
          label: "ประเภท",
          class: "w-50px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "13% !important",
          },
          type: 2,
        },
        {
          key: "discount",
          label: "ส่วนลด",
          class: "w-50px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "10% !important",
          },
          type: 2,
        },
        {
          key: "delete",
          label: "",
          class: "w-50px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "3% !important",
          },
          type: 0,
        },
      ],
      isBusy: false,
      productList: [],
      productListSelect: [],
      productListSelectDisplay: [],
      shippingMinimumType: [],
      filename: "",
      typeDiscountOption: [
        { value: 0, text: "Select type" },
        { value: 1, text: "Baht" },
        { value: 2, text: "Percent" },
        { value: 5, text: "AdvancePrice" },
      ],
    };
  },
  computed: {
    computedFields() {
      if (this.form.promotion.promotionTypeId == 5) {
        return this.fields.filter((field) => field.type != 3);
      } else if (this.form.promotion.promotionTypeId == 6) {
        return this.fields.filter(
          (field) => field.type == 0 || field.type == 1 || field.type == 3
        );
      } else {
        return this.fields.filter((field) => field.type == 0);
      }
    },
  },
  created: function() {
    if (this.id != 0) {
      this.getProductSelect();
      if (
        this.form.privilage.promotionConditionScope.promotionScopeTypeId == 1
      ) {
        this.changeScope(1);
      }
    } else {
      this.form.promotion.promotionTypeId = 3;
    }
    this.getShippingTypeList();
  },
  methods: {
    setAppliedProduct() {
      this.form.appliedProduct = this.productListSelect.map((el) => {
        return {
          id: el.id,
          isApply: el.isApply,
          name: el.name,
          quantity: el.quantity,
          minimumTypeId: el.minimumTypeId,
          minimumPrice: el.minimumPrice,
        };
      });

      this.form.privilage.promotionConditionScope.productOrCategoryList = this.productListSelect.map(
        (el) => {
          return el.id;
        }
      );

      this.form.privilage.promotionConditionScope.productNameList = this.productListSelect.map(
        (el) => {
          return el.name;
        }
      );
    },
    getShippingTypeList() {
      this.axios
        .get(`${this.$baseUrl}/promotion/ShippingMinimumType`)
        .then((type) => {
          if (type.result == 1) {
            type.detail.forEach((e) => {
              this.shippingMinimumType.push({ value: e.id, text: e.name });
            });
          }
        });
    },
    changeScope(scope) {
      this.form.privilage.promotionConditionScope.promotionScopeTypeId = scope;
    },
    changeScopeType(type) {
      this.form.privilage.promotionConditionScope.conditionOperationTypeId = type;
      this.getProductSelect();
    },
    pagination(Page) {
      this.filterProductSelect.pageNo = Page;
      this.getProductSelect();
    },
    hanndleChangePerpage(value) {
      this.filterProductSelect.pageNo = 1;
      this.filterProductSelect.perPage = value;
      this.getProductSelect();
    },
    openProductModal(value) {
      this.$emit("openProductModal", "discount");
    },
    async getProductSelect(isSearch) {
      this.isBusy = true;
      this.axios
        .post(`${this.$baseUrl}/category/getProductList`, {
          type: this.form.privilage.promotionConditionScope
            .conditionOperationTypeId,
          search: this.filterProductSelect.search,
          pageNo: this.filterProductSelect.pageNo,
          perPage: this.filterProductSelect.perPage,
          isProductInCategory: this.filterProductSelect.isProductInCategory,
          productIdList: this.form.privilage.promotionConditionScope
            .productOrCategoryList,
          categories: [0, 0, 0, 0],
        })
        .then(async (data) => {
          if (data.result == 1 && !isSearch) {
            this.productListSelect = data.detail.dataList;
            if (this.form.appliedProduct.length > 0) {
              this.form.appliedProduct.forEach((element) => {
                this.productListSelect.forEach((product) => {
                  if (product.id == element.id) {
                    product.isApply = element.isApply;
                    product.quantity = element.quantity;
                    product.minimumTypeId = element.minimumTypeId;
                    product.minimumPrice = element.minimumPrice;
                  }
                });
              });
            } else {
              this.productListSelect.forEach((product) => {
                product.isApply = true;
                product.quantity = 1;
                product.minimumTypeId = 0;
                product.minimumPrice = 0;
              });
            }
            this.productListSelectDisplay = this.productListSelect;
          } else {
            this.productListSelectDisplay = data.detail.dataList;
            this.form.appliedProduct.forEach((element) => {
              this.productListSelectDisplay.forEach((product) => {
                if (product.id == element.id) {
                  product.isApply = element.isApply;
                  product.quantity = element.quantity;
                  product.minimumTypeId = element.minimumTypeId;
                  product.minimumPrice = element.minimumPrice;
                }
              });
            });
          }
          this.rowsSelect = data.detail.count;
          this.isBusy = false;
        });
    },
    changeSameScope(value) {
      this.$emit("changeSameScope", value);
      if (!value) {
        this.form.privilage.promotionConditionScope.productOrCategoryList = [];
        this.form.privilage.promotionConditionScope.productNameList = [];
        this.getProductSelect();
      }
    },
    importPromotionData() {
      this.$emit("openUploadFile", "discount");
    },
    submitFilter() {
      this.filterProductSelect.pageNo = 1;
      this.filterProductSelect.perPage = 10;
      this.getProductSelect(true);
    },
    setChangeType() {
      this.productListSelect = [];
      this.productListSelectDisplay = [];
      this.rowsSelect = 0;
    },
    changeShippingType(type) {
      this.form.privilage.minimumTypeId = type;
    },
    changeDiscountType(value, index) {
      this.productListSelect[index].minimumTypeId = value;
    },
    deleteProduct(index) {
      this.productListSelect.splice(index, 1);
      this.productListSelect.forEach((e, index) => {
        e.index = index;
      });
      this.rowsSelect -= 1;
      this.$emit("deleteProduct", { type: "discount", index: index });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-collapse {
  color: #333333;
}
.text-gray {
  color: #bcbcbc;
}
.btn-purple {
  color: #ffffff;
  background-color: #7160c4;
}
::v-deep .btn-select {
  height: 42.4px;
  color: #404040;
  background-color: white;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  padding: 9px 10px;
  cursor: pointer;
}
::v-deep .btn-select.custom-select-lg {
  height: 55px;
  font-size: 1rem;
}
::v-deep .btn-select:focus {
  border-color: #80c141;
}
::v-deep .btn-select > option {
  background-color: white;
  color: #16274a;
}
::v-deep .btn-select > option:checked {
  color: #16274a !important;
}
::v-deep .btn-select:focus {
  box-shadow: unset !important;
}
.btn-select-product {
  width: 150px;
}
.search-input {
  height: 42.4px;
  border: 1px solid #b5b5b5;
  border-radius: 7px;
}
.btn-table-select {
  height: 42.4px;
}
.cb-table {
  position: relative;
  margin-left: 15px;
  padding-top: 15px;
}
</style>
